import { ITerm } from '../../types/interfaces';

export function hasTerm<T>(obj: ITerm<T> = {} as ITerm<T>, val: T): boolean {
  return obj.value === val;
}
